import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionPlacementType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { Activity } from './activity-history-configuration';

export class ItineraryActivityAttributesConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ItineraryActivityAttributesConfiguration';
  nodataLocalizationKeyName = 'activityAttributes';
  readonly reportSection = ReportSection.ItineraryActivityAttributes;
  readonly applicableReportTypes = [ReportType.Itinerary];
  readonly reportViewModelSections = [ReportViewModelSection.Itinerary_ActivityAttributes];
  maxSize = 3;
  minSize = 3;
  defaultSize = 3;
  override disabledLayoutWidthControl = true;
  name = 'activityAttributes';
  readonly availableDataSections = [
    {
      name: 'companyContacts',
      displayName: 'Company Contacts',
      isSelected: true,
      canConfigure: true,
      property: 'companyContacts'
    },
    {
      name: 'activityNotes',
      displayName: 'Activity Notes',
      isSelected: false,
      canConfigure: true,
      property: 'activityNotes'
    },
    {
      name: 'activityCustomFields',
      displayName: 'Activity Custom Fields',
      isSelected: false,
      canConfigure: true,
      property: 'activityCustomFields'
    }
  ];

  get displayName(): string {
    if (this.appliedReportType === ReportType.Itinerary) {
      return 'Activity Attributes';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface ActivityAttribute {
  activity: Activity;
}

export interface ActivityAttributeData {
  [ReportViewModelSection.Itinerary_ActivityAttributes]: ActivityAttribute;
}
